import React from 'react'
/* eslint react/prop-types: 0 */

export const BatteryFullIcon = props => (
  <svg width="26px" height="12px" viewBox="0 0 26 12" {...props}>
    <g fill="none" fillRule="evenodd">
      <path d="M2 0h20a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2z" />
      <path d="M2 .5A1.5 1.5 0 0 0 .5 2v8A1.5 1.5 0 0 0 2 11.5h20a1.5 1.5 0 0 0 1.5-1.5V2A1.5 1.5 0 0 0 22 .5H2z" stroke="#D1D1D1" />
      <path fill="#58E597" d="M2 2h6v8H2zM9 2h6v8H9zM16 2h6v8h-6z" />
      <path d="M25 4a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1V4z" fill="#D1D1D1" />
    </g>
  </svg>
)

export const BatteryMediumIcon = props => (
  <svg width="26px" height="12px" viewBox="0 0 26 12" {...props}>
    <g fill="none" fillRule="evenodd">
      <path d="M2 0h20a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2z" />
      <path d="M2 .5A1.5 1.5 0 0 0 .5 2v8A1.5 1.5 0 0 0 2 11.5h20a1.5 1.5 0 0 0 1.5-1.5V2A1.5 1.5 0 0 0 22 .5H2z" stroke="#D1D1D1" />
      <path fill="#FFC10E" d="M2 2h6v8H2zM9 2h6v8H9z" />
      <path d="M25 4a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1V4z" fill="#D1D1D1" />
    </g>
  </svg>
)

export const BatteryLowIcon = props => (
  <svg width="26px" height="12px" viewBox="0 0 26 12" {...props}>
    <g fill="none" fillRule="evenodd">
      <path d="M2 0h20a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2z" />
      <path d="M2 .5A1.5 1.5 0 0 0 .5 2v8A1.5 1.5 0 0 0 2 11.5h20a1.5 1.5 0 0 0 1.5-1.5V2A1.5 1.5 0 0 0 22 .5H2z" stroke="#D1D1D1" />
      <path fill="#FF5A0E" d="M2 2h6v8H2z" />
      <path d="M25 4a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1V4z" fill="#D1D1D1" />
    </g>
  </svg>
)

export const BatteryCriticalIcon = props => (
  <svg width="26px" height="12px" viewBox="0 0 26 12" {...props}>
    <g fill="none" fillRule="evenodd">
      <path d="M2 0h20a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2z" />
      <path d="M2 .5A1.5 1.5 0 0 0 .5 2v8A1.5 1.5 0 0 0 2 11.5h20a1.5 1.5 0 0 0 1.5-1.5V2A1.5 1.5 0 0 0 22 .5H2z" stroke="#D1D1D1" />
      <path d="M25 4a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1V4z" fill="#D1D1D1" />
    </g>
  </svg>
)

export const BirdIcon = props => (
  <svg width="100%" height="100%" viewBox="0 0 97 97" {...props}>
    <defs>
      <circle id="a" cx="48.5" cy="48.5" r="48.5" />
      <path id="c" d="M.4.2h47.2v31.3H.4z" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="b" fill="#fff">
        <use xlinkHref="#a" />
      </mask>
      <circle cx="48.5" cy="48.5" r="48" stroke="#425667" />
      <g mask="url(#b)">
        <path
          fill="#425667" d="M17.9 28.7s15.4 3.6 18.4 13.8c0 0 .1 4.1-.5 4-.4 0-5.7-6-12.7-2 5 1.5 8.8 1.2 14.2 10.6 1.8 
          3 3.4 1.2 7.3-.5 2.8-1.1 1.3-1 8.1-.5 5 .2 8.9-2.6 11.8-7 .7-2.3-7.3-10.7-14.3-16-2.1 1.1-5.4 1.3-5.4 1.3s-13.3-11.1-27-3.7"
        />
        <g transform="translate(17.5 25.8)">
          <mask id="d" fill="#fff">
            <use xlinkHref="#c" />
          </mask>
          <path
            fill="#425667" d="M7.1.5C9.5 0 12 0 14.4.5a28.3 28.3 0 0 1 13.2 5.8l-.3-.1A18.2 18.2 0 0 0 32.5 5l.2-.1.2.1a73 73 0 0 1 13.7 13.4 9 9 0 0 1 1 2l-.1 1a19.3 
            19.3 0 0 1-4.3 4.8 11.8 11.8 0 0 1-7.5 2.6H34l-3.1-.2h-1.5l-1.3.3-2.8 1.3-1.4.7-1.6.5h-1c-.3 0-.6-.2-.9-.4-.5-.4-.8-.9-1.1-1.3a46 46 0 0 0-3.5-5 13.6 13.6 
            0 0 0-4.6-3.7c-1.7-1-3.8-1.2-5.8-2l-1-.3 1-.6a9.9 9.9 0 0 1 9-.5 12.9 12.9 0 0 1 3.8 2.5V20l.2-1v-2.3.1c-.5-1.9-1.5-3.6-2.7-5a21.3 21.3 0 0 0-4.5-4A33.5 
            33.5 0 0 0 .4 2.9C2.4 1.7 4.8 1 7 .5zM3.3 3.7a37 37 0 0 1 8.2 3.8c1.7 1 3.3 2.3 4.6 3.8a14 14 0 0 1 3 5.3v.1a27.7 27.7 0 0 1-.1 3.5c0 .2 0 .4-.3.6l-.3.3H18.1L18 
            21l-.3-.2a19 19 0 0 0-3.7-2.3 9 9 0 0 0-4.1-.8c-1.5.2-3.4.7-3 .8 1.6.4 3.2.8 4.8 1.5a17.2 17.2 0 0 1 5 3.9 26.7 26.7 0 0 1 3.6 5.2l.9 1c.3.2.6.3 1 .2.4 0 .9-.3 
            1.4-.5l1.3-.6 2.9-1.3.7-.4 1-.1H31l3 .2h1.6a10.4 10.4 0 0 0 6.8-2.2c1.6-1.2 3-2.8 4-4.5v.1c0-.1 0-.6-.2-1a52.4 52.4 0 0 0-5.7-7.3 78 78 0 0 0-8.1-7h.4a11.6 
            11.6 0 0 1-4.1 1.1l-1.5.1H27a21.8 21.8 0 0 0-3-2 32.4 32.4 0 0 0-9.8-4 21.8 21.8 0 0 0-14 2l3 .8z" mask="url(#d)"
          />
        </g>
        <path
          fill="#FBFBFB" d="M60 46.8a3.8 3.8 0 1 1-6.9-3.3 3.8 3.8 0 0 1 6.9 3.3M44.7 48s-1.1 3.1-5.3 4.8c-4.1 1.7-8.3 13.6-1 17.5 7.6 4 13.1-.6 15.2-4.8 2.4-4.9 
          0-11.7-.3-14-1 1-2.8 3.3-5 2.5-2.4-1-3.6-3-3.6-6"
        />
        <path
          fill="#425667" d="M44.8 48.9l.1.8a7.7 7.7 0 0 0 .6 1.6 4.7 4.7 0 0 0 3.7 2.5c.5 0 1-.2 1.4-.5a7 7 0 0 0 1.2-1l1.2-1.2.6-.6.1.9.8 3.6.7 3.8-.1 3.9a12.5 
          12.5 0 0 1-7 9 10 10 0 0 1-4 .8 11.8 11.8 0 0 1-5.6-1.5c-.6-.3-1.2-.7-1.7-1.2-1-.8-1.9-2-2.3-3.3-.5-1.2-.6-2.6-.6-3.9a14.4 14.4 0 0 1 2.4-7.3c.7-1 1.5-2 
          2.8-2.7l.9-.3.8-.4 1.5-1c1-.8 1.9-1.7 2.4-2.8l.1.8zM42.5 51L41 52.3l-.8.4-.9.4a7 7 0 0 0-2.4 2.6 13.8 13.8 0 0 0-2 7c0 1.2.2 2.3.7 3.4a6.6 6.6 0 0 0 3.4 
          3.7l.8.4.9.3c1.1.4 2.3.6 3.4.6a9 9 0 0 0 3.5-.7 11 11 0 0 0 6.3-8 29.8 29.8 0 0 0-.3-7.3l-.6-2.8c0-.2-1 1-2 1.7-.5.3-1.1.5-1.8.4l-.9-.1a6 6 0 0 1-2.2-1.5 
          5 5 0 0 1-1.2-2.2 7.1 7.1 0 0 1-.2-1.7v-.8a8.4 8.4 0 0 1-2.2 3zm7.1 21l1.4 2a55.1 55.1 0 0 1 11 27l2 15.2c.8 5.3 1.6 11 2.8 16.7a117.2 117.2 0 0 0 10.5 
          29.8l1.2 2 1.1 2.1a116.4 116.4 0 0 0 10.6 15 83.4 83.4 0 0 0 13 12.2l.9.7.9.6 1.7 1.3 3.6 2.3a193.5 193.5 0 0 0 20.5 11.2 91.3 91.3 0 0 0 30.2 7.4h-2.3A77 
          77 0 0 1 130 212a104.4 104.4 0 0 1-14-6.5l-7.3-4.2-3.7-2.2-1.8-1.3-1-.6-.9-.7a80.2 80.2 0 0 1-19.6-20c-1.8-2.5-3.6-5.2-5.2-8l-1.1-2-1.2-2.2a116.5 116.5 
          0 0 1-5.8-13c-2.2-6-3.6-12-4.7-18a207.7 207.7 0 0 1-3.1-24.8l-.7-7.3-1-6.6-.6-3-.7-2.9c-1-3.6-2.4-6.7-3.6-9.1l-1.8-3.3-1.4-2.3-1.2-2m-2.2-40.1l.5-.2a40.4 
          40.4 0 0 1 8-2.6 30.7 30.7 0 0 1 10.3 0A26.4 26.4 0 0 1 78.4 35a176.7 176.7 0 0 1 5.5 5.4c1.9 1.9 3.7 4 5.4 6.3l.6.8.6.9 1.2 1.8 2.4 3.6a72 72 0 0 0 5.1 
          7 35 35 0 0 0 8.3 7.2l2 1.1 4.2 2.3 4.2 2.5 2 1.3 2.1 1.3a145.1 145.1 0 0 1 22.3 19l6.7 6.7 1.5 1.8 1.6 1.8a86.1 86.1 0 0 1 12 18.8 150 150 0 0 1 10.8 27 
          161.8 161.8 0 0 1 4 16.3l.4 2.3-.6-2.3a188.7 188.7 0 0 0-13.2-35 118.5 118.5 0 0 0-15.9-25l-1.5-1.7-1.6-1.7-3.3-3.3-3.3-3.4a141.5 141.5 0 0 
          0-30-23.3l-4-2.3-2.2-1.2a38.2 38.2 0 0 1-9-8.1c-1.9-2.4-3.6-5-5.1-7.5l-2.2-3.7-1.2-1.8-.5-.8-.6-.9a69.2 69.2 0 0 0-10-11.6A26.2 26.2 0 0 0 56 29.8a37 37 0 0 0-8.6 2.1"
        />
        <path
          fill="#425667" d="M73.5 96.3l-.7 4.8a104 104 0 0 0-.8 12.4 49.5 49.5 0 0 0 3.6 17c.7 1.4 1.2 3 2 4.4l1 2.3 1.2 2.2.6 1 .7 1.1 1.3 2.2 1.5 2 1.5 2.1a75 75 
          0 0 0 6.6 7.7l1.8 1.8 1.9 1.7 1.8 1.6 1.9 1.5 1.8 1.5 2 1.4 1.8 1.3 1.9 1.2 1.8 1.2 1 .5.9.5 3.5 2c1.1.6 2.3 1 3.3 1.6l1.6.8 1.5.6 2.7 1.2a1609.6 1609.6 
          0 0 0 2.3 1l3.3 1.1 1.2.5-1.2-.3-3.5-.8-1.1-.3-1.3-.4-2.8-1c-.6 
          0-1-.2-1.6-.4l-1.6-.7-3.5-1.4-3.8-1.7-1-.5-.9-.5-2-1.1-2-1.2-2-1.2-2-1.3-2-1.5-2-1.5-1.9-1.7-2-1.6-1.8-1.9a77.2 77.2 0 0 
          1-7-7.9l-1.5-2.1-1.5-2.2-1.4-2.3-.7-1.1-.6-1.2-1.2-2.3-1-2.4c-.8-1.5-1.3-3-1.9-4.6a53 53 0 0 1-3-17.9 46.6 46.6 0 0 1 2-12.5l1-3.5.3-1.2M57.8 
          45.6a2 2 0 1 1-3.5-1.8 2 2 0 0 1 3.5 1.8"
        />
        <path
          fill="#FBFBFB" d="M51 31.9h-.6l-.4.5c-.3.3-.7.5-1.1.6l-1.2.4c-.4 0-.9.1-1.1.3v.1l.4.5.7.9.7.9.4.5.4.5.7 1 .4 1.1.3 1.2v.7l-.2.5v-1.1l-.5-1.1a6.8 6.8 0 
          0 0-1.2-2l-.4-.4-.4-.5-.7-.9a12.2 12.2 0 0 1-1.1-1.5l-.1-.4v-.3l.3-.3.7-.2h.6l1.2-.2 1-.5.6-.3h.6"
        />
      </g>
      <path fill="#419EF6" fillRule="nonzero" stroke="#FBFBFB" d="M59 50a18 18 0 0 0-2.5 6 2.5 2.5 0 1 0 5 0c0-1-.8-3-2.5-6z" mask="url(#b)" />
    </g>
  </svg>
)

export const UploadIcon = props => (
  <svg width="31" height="38" {...props}>
    <g fill="#F37021" fillRule="nonzero" stroke="none" strokeWidth="1">
      <path d="M21.9.8a3 3 0 0 0-2-.8H5a5 5 0 0 0-5 5v28a5 5 0 0 0 5 5h22.9c.4 0 
      .7-.4.7-.8s-.3-.7-.7-.7h-23c-1.8 0-3.4-1.6-3.4-3.5V5c0-2 1.6-3.5 3.5-3.5H20v6.7c0 1.6 1.3 2.9 2.9 2.9h6.6v22c0 
      .4.3.7.7.7.4 0 .8-.3.8-.7V11c0-.6-.4-1.4-.8-2L21.9.9zm-.4 7.4V2.6l7 7h-5.6c-.8 0-1.4-.6-1.4-1.4z"
      />
      <path d="M9.2 18.9c.3.3.7.3 1 0l4.2-4.3v10.8c0 .4.3.7.8.7.4 0 .7-.3.7-.7V14.6l4.2 4.3c.3.3.8.3 1 0 .3-.3.3-.8 0-1l-5.4-5.6a.7.7 0 0 0-1 0l-5.5 5.5c-.3.3-.3.8 0 1z" />
    </g>
  </svg>

)

export const LocationIcon = props => (
  <svg width="36" height="36" viewBox="0 0 36 36" {...props}>
    <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
      <circle cx="18" cy="18" r="5.5" fill="#419EF6" fillRule="nonzero" />
      <circle cx="18" cy="18" r="13.1" stroke="#419EF6" strokeWidth="1.8" />
      <path stroke={props.color || '#419EF6'} strokeLinecap="square" strokeWidth="2" d="M32.1 17.9H35M1.2 17.9h2.4M17.9 3.6V1M17.9 35v-2.5" />
    </g>
  </svg>
)

export const HeatmapToggleIcon = props => (
  <svg width="100%" height="100%" viewBox="0 0 55.5 55.5" {...props}>
    <path
      fill="#4198d4" d="M44.1 22a1.7 1.7 0 0 0-2.1-1l-2.6 1v-4.4a1.7 1.7 0 1 0-3.3 0v5.5L33 
      24v-6.5a1.7 1.7 0 1 0-3.3 0v7.7l-3 1v-8.7a1.7 1.7 0 1 0-3.4 0v10l-3 1v-11a1.7 1.7 0 1 0-3.4 
    0v12.2l-4.5 1.6a1.7 1.7 0 0 0-1 2.1 1.7 1.7 0 0 0 1.6 1.1 1.4 1.4 0 0 0 .6 0l3.3-1.2v4.5a1.7 
    1.7 0 0 0 3.3 0v-5.7l3-1v6.7a1.7 1.7 0 1 0 3.4 0v-8l3-1v9a1.7 1.7 0 1 0 3.4 
    0V27.6l3-1.1v11.3a1.7 1.7 0 0 0 1.7 1.7 1.7 1.7 0 0 0 1.6-1.7V25.4l3.8-1.3a1.7 1.7 0 0 0 1-2.1z"
    />
  </svg>
)

export const OverviewTooltipBackground = props => (
  <svg width="100%" height="100%" viewBox="0 0 200 100" {...props}>
    <defs>
      <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
        <stop offset="0%" stopColor="#F8F8F8" />
        <stop offset="100%" stopColor="#EDEDED" />
      </linearGradient>
      <path id="b" d="M20.5.4h126.6a4 4 0 0 1 4 4v61a4 4 0 0 1-4 4H20.5a4 4 0 0 1-3.5-2.1l-17-32L17 2.6A4 4 0 0 1 20.5.4z" />
      <filter id="a" width="132.4%" height="171%" x="-16.2%" y="-25.4%" filterUnits="objectBoundingBox">
        <feOffset dx="0" dy="7" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="7" />
        <feComposite in="shadowBlurOuter1" in2="SourceAlpha" operator="out" result="shadowBlurOuter1" />
        <feColorMatrix in="shadowBlurOuter1" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0" />
      </filter>
    </defs>
    <g fill="none" fillRule="nonzero" stroke="none" strokeWidth="1" transform="translate(13 6)">
      <use fill="#000" fillOpacity="1" filter="url(#a)" xlinkHref="#b" />
      <path
        fill="#FFF"
        fillRule="evenodd"
        stroke="url(#c)"
        strokeLinejoin="square"
        strokeWidth=".5"
        d="M.3 35.3l16.9 31.9c.6 1.2 2 2 3.3 2h126.6c2.1 0 3.8-1.7 3.8-3.8v-61c0-2-1.7-3.7-3.8-3.7H20.5c-1.4 0-2.7.7-3.3 2L.2 35.3z"
      />
    </g>
  </svg>
)

export default UploadIcon



// WEBPACK FOOTER //
// ./src/assets/SVGIcons.js